import { createComponentStore } from './createComponentStore';
export const useSpecificationOrderComponentStore = createComponentStore('specificationOrderComponent');
